module.exports = __webpack_public_path__ + "static/media/Joan_Joe_event.d52995f0.jpg";